module.exports = __webpack_public_path__ + "files/7c31d7ec21915b5c764c6838db5c216e.png";